import { defineFcm } from '../shared/factory';

export const FCM_PROMOTED_PETITIONS_USE_UNFILTERED_LIST = defineFcm('promoted_petitions_use_unfiltered_list')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'promotion-service',
		context: 'promotion-service',
		description:
			'Specifies using the unfiltered list of promoted petitions instead of the paced list. The unfiltered list should be used in instances where there are an insufficient number of promoted petitions in the paced list.',
	});
